import React, { useContext } from "react";
import "./../Footer/Footer.css";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaPhoneVolume,
} from "react-icons/fa";
import { BsTwitter } from "react-icons/bs";
import CommonContext from "../../Context/context";
import {
  helperText,
  htmlRegexG,
  lengthFindOfPara,
} from "../../Helper/helperFunctions";

const Footer = () => {
  const { cmsData, ContactNumber, LocationLink, AllLink } =
    useContext(CommonContext);

  const footerContent = cmsData?.find((ele) =>
    ele?.page?.toLowerCase()?.includes("footer")
  );

  let text = footerContent?.description;

  const faceBookLink = AllLink.find((e) => e?.includes("www.facebook.com"));
  const Instagram = AllLink.find((e) => e?.includes("www.instagram.com"));
  const tweeterLink = AllLink.find((e) => e?.includes("https://twitter.com/"));
  return (
    <>
      <footer className="main-footer">
        <div className="container-fluid">
          <div className="widgets-section">
            <div className="row clearfix">
              <div className="column col-lg-3 col-md-6">
                <div className="widget about-widget">
                  <div className="logo">
                    <h5 className="mb-0">
                      Bharatpur St. Mary (Eng.) School (H.S)
                    </h5>
                  </div>
                  <div className="text">
                    {!text && <small>{helperText.slice(0, 50)}</small>}
                    {text?.length > 200 ? (
                      <small>
                        {text?.replace(htmlRegexG, "")?.slice(0, 200)}
                      </small>
                    ) : (
                      text?.replace(htmlRegexG, "")
                    )}
                  </div>
                  <ul className="social-links">
                    {faceBookLink && (
                      <li>
                        <Link to={faceBookLink || ""}>
                          <FaFacebookF />
                        </Link>
                      </li>
                    )}
                    {tweeterLink && (
                      <li>
                        <Link to={tweeterLink || ""}>
                          <BsTwitter />
                        </Link>
                      </li>
                    )}
                    {Instagram && (
                      <li>
                        <Link to={Instagram || ""}>
                          <FaInstagram />
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </div>

              <div className="column col-lg-3 col-md-6">
                <div className="widget links-widget">
                  <h3 className="widget-title">Quick Links</h3>
                  <div className="widget-content footer-links">
                    <ul>
                      <li>
                        <Link to="/about">About Us</Link>
                      </li>
                      <li>
                        <Link to="/gallery">Gallery</Link>
                      </li>
                      <li>
                        <Link to="/notice">Notice Board</Link>
                      </li>
                      <li>
                        <Link to="/recruitment">Recruitment</Link>
                      </li>

                      <li>
                        <Link to="/admission">Admission</Link>
                      </li>
                    </ul>
                    <ul>
                      <li>
                        <Link to="/contact">Contact Us</Link>
                      </li>
                      <li>
                        <Link to="/privacypolicy">Privacy Policy</Link>
                      </li>
                      <li>
                        <Link to="/terms&conditions">Terms & Conditions</Link>
                      </li>
                      <li>
                        <Link to="/cancellation/refundpolicy">
                          Cancellation/Refund Policy
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="column col-lg-2 col-md-6">
                <div className="widget contact-widget">
                  <h3 className="widget-title">Contact Us</h3>
                  <div className="widget-content">
                    <ul className="contact-info">
                      <li>
                        <div className="icon">
                          <FaPhoneVolume />
                        </div>
                        <div className="text">
                          Helpline 24/7 <br />
                          <Link to="/">
                            {ContactNumber?.file
                              ? ContactNumber.file
                              : "0000000000"}
                          </Link>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="column col-lg-4 col-md-6">
                <div className="map">
                  <iframe
                    title="map"
                    src={
                      LocationLink?.file
                        ? LocationLink?.file
                        : "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d117925.33439927742!2d88.34735275!3d22.53542735!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f882db4908f667%3A0x43e330e68f6c2cbc!2sKolkata%2C%20West%20Bengal!5e0!3m2!1sen!2sin!4v1689575959008!5m2!1sen!2sin"
                    }
                    width="100%"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container">
            <div className="wrapper-box">
              <div className="text text-left">
                &copy; 2023 Bharatpur St. Mary (Eng.) School (H.S), All rights
                reserved.
              </div>
              <div className="text text-right">
                Design and Developed by
                <Link to="https://yeasitech.com/"> YEASITECH</Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
